import { setToken } from "../redux/reducers/auth";
import api from "./api";

export interface CreateUserRequest {
  name: string;
  email: string;
  password: string;
}

export interface UserLoginRequest {
  password: string;
  email: string;
}

export interface UserLoginResponse {
  token: string;
}

export interface GetUserInfoRequest {
  token: string;
  id: number;
}

interface VerifyEmailRequest {
  signupVerifyToken: string;
}

interface MyInfo {
  id: number;
  email: string;
  name: string;
  createAt: string;
}

const usersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    verifyEmail: builder.query<{ token: string }, VerifyEmailRequest>({
      query: (request) => ({
        url: "users/email-verify",
        params: request,
      }),
    }),
    createUser: builder.mutation<unknown, CreateUserRequest>({
      query: (request) => ({
        url: "users",
        body: request,
        method: "post",
      }),
    }),
    getMyInfo: builder.query<MyInfo, void>({
      query: () => "users/me",
    }),
    withdraw: builder.mutation<void, void>({
      query: () => ({
        url: "users/withdraw",
        method: "delete",
      }),
      invalidatesTags: ["clients", "user", "request"],
      onCacheEntryAdded: (_args, { dispatch }) => {
        dispatch(setToken(""));
      },
    }),
  }),
});

export const {
  useVerifyEmailQuery,
  useCreateUserMutation,
  useGetMyInfoQuery,
  useWithdrawMutation,
} = usersApi;
export default usersApi;
